import MuiAppBar from '@mui/material/AppBar';
import { styled } from '@mui/material/styles';

const AppBar = styled(MuiAppBar)(({ theme }) => ({
    background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
    boxShadow: 'none',
}));

export default AppBar;
